import dayjs from 'dayjs';
import { isNil } from 'lodash-es';
import {
  type FindOrderSummaryResponse,
  type OrderMode,
  PaymentMethodType,
} from '../../../../../resources/@types/courseSchema';

import { decodeHTMLEntities } from '../../../../lib/misc';
import { OrderStatus } from './OrderStatus';

/**
 * snake case를 camel case로 변경하고
 * _ 객체를 제거합니다.
 */
export default class OrderDTO {
  readonly id: number;
  readonly createdAt: string;
  readonly status: keyof typeof OrderStatus;

  readonly title: string;
  readonly payPrice: number;
  readonly regPrice: number;
  readonly receiptUrl: string | null;
  readonly currency: string;
  readonly createdAtUTC: string;
  readonly timezone: string;
  readonly isReceiptAvailable: boolean;
  readonly canGetInvoice: boolean;
  readonly paymentChannel: string;
  readonly paymentMethod: string;
  readonly orderMode: keyof typeof OrderMode;
  /**
   * 주문한 강의 수
   */
  readonly itemsCount: number;

  private _response: Required<FindOrderSummaryResponse>['items'][0];

  constructor(response: Required<FindOrderSummaryResponse>['items'][0]) {
    this._response = response;
    this.id = response.id;
    this.createdAt = dayjs(response.createdAt).format('YYYY.MM.DD');
    this.status = response.status as OrderDTO['status'];
    this.title = decodeHTMLEntities(response.title ?? '');

    this.payPrice = response.paymentPrice ?? 0;
    this.regPrice = response.regularPrice ?? 0;
    this.receiptUrl = response.receiptUrl;
    this.itemsCount = response?.itemsCount ?? 0;
    this.currency = response.currency;
    this.createdAtUTC = response.createdAtUTC;
    this.timezone = response.timezone;
    this.isReceiptAvailable = response.isReceiptAvailable;
    this.canGetInvoice = response.canGetInvoice;
    this.paymentChannel = response.paymentChannel;
    this.orderMode = response.orderMode;
    this.paymentMethod = response.paymentMethodType || PaymentMethodType.NONE;
  }

  get statusLabel() {
    return this.status === 'WC_COMPLETED' ? OrderStatus.PAYMENT_COMPLETE : OrderStatus[this.status];
  }

  get discountedPrice() {
    if (isNil(this.regPrice) || isNil(this.payPrice)) {
      return null;
    }

    return this.regPrice - this.payPrice;
  }
}
